import { HttpService } from '@/infra/http'

import type { TGetEmpreendimentosDisponiveisResponse } from '../types/empreendimento'

export class GetEmpreendimentosDisponiveisService extends HttpService {
  execute = async (apenasFuturo?: boolean) => {
    return this.http.get<TGetEmpreendimentosDisponiveisResponse>(`api/v2/Empreendimento/disponiveis`, {
      params: {
        apenasFuturo,
      },
    })
  }
}
